(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/platform-browser-dynamic"), require("reflect-metadata"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/platform-browser-dynamic", "reflect-metadata"], factory);
	else if(typeof exports === 'object')
		exports["mcfCore"] = factory(require("@angular/core"), require("@angular/platform-browser-dynamic"), require("reflect-metadata"));
	else
		root["mcfCore"] = factory(root["@angular/core"], root["@angular/platform-browser-dynamic"], root["reflect-metadata"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition